import {
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Col,
  Row,
  Table,
} from "reactstrap"
import { MdDelete, MdModeEdit } from "react-icons/md"
import { FaSort, FaSortAlphaDown, FaSortAlphaUp } from "react-icons/fa";
import { useContext, useEffect, useMemo, useRef, useState } from "react"
import {
  DataFilter,
  ItemsPerPage,
  SearchFilter,
} from "components/Common/filters"
import { useSelector, useDispatch } from "react-redux"
import PaginationComponent from "components/Common/pagination"
import Loader from "components/Common/loader"
import { allStudents, StudentsFetch } from "redux/slice/students/studentsSlice"
import { calculateAge, DateFormater, DateTimeFormatter } from "utilities/dateformater"
import SidebarContext from "context/sidebar.context"

export default function StudentsTable(props) {
  const dispatch = useDispatch()
  const { studentsData, loading, totalPages } = useSelector(allStudents)
  const { currentPage, setCurrentPage, itemsPerPage, setItemsPerPage } = useContext(SidebarContext)
  // const [itemsPerPage, setItemsPerPage] = useState(5)
  // const [currentPage, setCurrentPage] = useState(1)
  const [searchTerm, setSearchTerm] = useState("")
  const [filters, setFilters] = useState({})
  const [sortBy, setSortBy] = useState({
    label: "",
    order: false
  })

  const debounceTimeout = useRef(null)
  const searchedData = text => {
    setSearchTerm(text)
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current)
    }

    debounceTimeout.current = setTimeout(() => {
      let data = {
        Search: text,
        pageNumber: currentPage,
        pageSize: itemsPerPage,
        asce: sortBy.order,
        SortBy: sortBy.label ? sortBy.label : null
      }
      console.log("data search", data)
      dispatch(StudentsFetch(data))
    }, 1200)
  }

  // const searchedData = useMemo(() => {
  //   return studentsData.filter(item =>
  //     Object.values(item).some(value =>
  //       String(value).toLowerCase().includes(searchTerm.toLowerCase())
  //     )
  //   );  
  // }, [studentsData, searchTerm]);

  
  const handleSorting = (_sortby) => {
    if(sortBy.label === _sortby){
      setSortBy((prev)=>({
        ...prev,
        order: !sortBy.order
      }))
    } else {
      setSortBy((prev)=>({
        ...prev,
        label: _sortby,
        order: true
      }))
    }
  }

  const paginate = pageNumber => {
    console.log("paginate call with page number: ", pageNumber)
    setCurrentPage(pageNumber)
    let data = {
      Search: searchTerm,
      pageNumber: pageNumber,
      pageSize: itemsPerPage,
      asce: sortBy.order,
      SortBy: sortBy.label ? sortBy.label : null
    }
    dispatch(StudentsFetch(data))
  }

  useEffect(() => {
    let data = {
      Search: searchTerm,
      pageNumber: currentPage,
      pageSize: itemsPerPage,
      asce: sortBy.order,
      SortBy: sortBy.label ? sortBy.label : null
    }
    dispatch(StudentsFetch(data))
  }, [itemsPerPage, filters, sortBy])

  const handleItemsPerPage = perPage => {
    console.log("items per page", perPage)
    if(perPage !== itemsPerPage){
      setCurrentPage(1)
    }
    setItemsPerPage(Number(perPage))
  }

  const handleUpdate = received => {
    console.log("update", received)
    props.forUpdate(received)
  }

  const handleDelete = () => {
    console.log("deleting")
  }

  return (
    <div className="application-table-container">
      <Row>
        <Col lg={12}>
          <Card className="app-table-card">
            <CardTitle className="fs-2 ms-3 dot-after">Students</CardTitle>
            <CardBody>
              <div
                className="d-flex justify-content-end flex-row align-items-center"
                style={{ width: "100%" }}
              >
                <div className="me-3">
                  <SearchFilter
                    value={searchTerm}
                    label="Search Student"
                    onChange={e => {
                      searchedData(e.target.value)
                    }}
                  />
                </div>
                <div>
                  <ItemsPerPage
                    value={itemsPerPage}
                    handleItemsPerPage={handleItemsPerPage}
                  />
                </div>
              </div>

              <div className="app-table-body">
                {loading ? (
                  <Loader />
                ) : (
                  <Table className="table mb-0 table-striped table-bordered h-100">
                    <thead>
                      <tr>
                        <th className="table-header-sort" onClick={() => handleSorting("applicationId")}>
                          <div className="header-content">
                            <span className="text-nowrap table-head-label">Application Id</span>
                            {sortBy.label === "applicationId" &&
                              sortBy.order && <FaSortAlphaDown color="red" />}
                            {sortBy.label === "applicationId" &&
                              !sortBy.order && <FaSortAlphaUp color="red" />}
                          </div>
                        </th>
                        <th className="table-header-sort" onClick={() => handleSorting("firstName")}>
                          <div className="header-content">
                            <span className="text-nowrap table-head-label">Student Name</span>
                            {sortBy.label === "firstName" &&
                              sortBy.order && <FaSortAlphaDown color="red" />}
                            {sortBy.label === "firstName" &&
                              !sortBy.order && <FaSortAlphaUp color="red" />}
                          </div>
                        </th>
                        <th className="text-nowrap">Email</th>
                        {/* <th className="table-header-sort" onClick={() => handleSorting("email")}>
                          <div className="header-content">
                            <span className="text-nowrap table-head-label">Email</span>
                            {sortBy.label === "email" &&
                              sortBy.order && <FaSortAlphaDown color="red" />}
                            {sortBy.label === "email" &&
                              !sortBy.order && <FaSortAlphaUp color="red" />}
                          </div>
                        </th> */}
                        <th className="text-nowrap">Contact Number</th>

                        <th className="table-header-sort" onClick={() => handleSorting("dateOfBirth")}>
                          <div className="header-content">
                            <span className="text-nowrap table-head-label">Date Of Birth</span>
                            {sortBy.label === "dateOfBirth" &&
                              sortBy.order && <FaSortAlphaDown color="red" />}
                            {sortBy.label === "dateOfBirth" &&
                              !sortBy.order && <FaSortAlphaUp color="red" />}
                          </div>
                        </th>
                        <th className="table-header-sort" onClick={() => handleSorting("dateOfBirth")}>
                          <div className="header-content">
                            <span className="text-nowrap table-head-label">Age</span>
                            {sortBy.label === "dateOfBirth" &&
                              sortBy.order && <FaSortAlphaDown color="red" />}
                            {sortBy.label === "dateOfBirth" &&
                              !sortBy.order && <FaSortAlphaUp color="red" />}
                          </div>
                        </th>
                        <th
                          className="table-header-sort"
                          onClick={() => handleSorting("city")}
                        >
                          <div className="header-content">
                            <span className="text-nowrap table-head-label">City</span>
                            {sortBy.label === "city" &&
                              sortBy.order && <FaSortAlphaDown color="red" />}
                            {sortBy.label === "city" &&
                              !sortBy.order && <FaSortAlphaUp color="red" />}
                          </div>
                        </th>
                        <th
                          className="table-header-sort"
                          onClick={() => handleSorting("country")}
                        >
                          <div className="header-content">
                            <span className="text-nowrap table-head-label">Country</span>
                            {sortBy.label === "country" &&
                              sortBy.order && <FaSortAlphaDown color="red" />}
                            {sortBy.label === "country" &&
                              !sortBy.order && <FaSortAlphaUp color="red" />}
                          </div>
                        </th>
                        <th className="table-header-sort" onClick={() => handleSorting("homeAddress")}>
                          <div className="header-content">
                            <span className="text-nowrap table-head-label">Address</span>
                            {sortBy.label === "homeAddress" &&
                              sortBy.order && <FaSortAlphaDown color="red" />}
                            {sortBy.label === "homeAddress" &&
                              !sortBy.order && <FaSortAlphaUp color="red" />}
                          </div>
                        </th>
                        <th className="table-header-sort" onClick={() => handleSorting("applicationStatus")}>
                          <div className="header-content">
                            <span className="text-nowrap table-head-label">Status</span>
                            {sortBy.label === "applicationStatus" &&
                              sortBy.order && <FaSortAlphaDown color="red" />}
                            {sortBy.label === "applicationStatus" &&
                              !sortBy.order && <FaSortAlphaUp color="red" />}
                          </div>
                        </th>
                        <th className="table-header-sort" onClick={() => handleSorting("submittedDate")}>
                          <div className="header-content">
                            <span className="text-nowrap table-head-label">Date Created</span>
                            {sortBy.label === "submittedDate" &&
                              sortBy.order && <FaSortAlphaDown color="red" />}
                            {sortBy.label === "submittedDate" &&
                              !sortBy.order && <FaSortAlphaUp color="red" />}
                          </div>
                        </th>
                        {/* <th className="table-header-sort" onClick={() => handleSorting("programDuration")}>
                          <div className="header-content">
                            <span className="text-nowrap table-head-label">Program Length</span>
                            {sortBy.label === "programDuration" &&
                              sortBy.order && <FaSortAlphaDown color="red" />}
                            {sortBy.label === "programDuration" &&
                              !sortBy.order && <FaSortAlphaUp color="red" />}
                          </div>
                        </th> */}
                        <th className="text-nowrap">Program Length</th>
                        {/* <th className="text-nowrap">Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {studentsData.map((std, index) => (
                        <tr key={index}>
                          <td className="text-nowrap">{std.applicationId}</td>
                          <td className="text-nowrap">
                            {std?.firstName
                              ? std?.firstName + " " + std?.lastName
                              : "--"}
                          </td>
                          <td className="text-nowrap">
                            {std?.email ? std?.email : "--"}
                          </td>
                          <td className="text-nowrap">
                            {std?.phoneNumber ? std?.phoneNumber : "--"}
                          </td>
                          <td className="text-nowrap">
                            {std?.dateOfBirth
                              ? DateFormater(std?.dateOfBirth)
                              : "--"}
                          </td>
                          <td className="text-nowrap">
                            {std?.dateOfBirth
                              ? calculateAge(std?.dateOfBirth)
                              : "--"}
                          </td>
                          <td className="text-nowrap">
                            {std?.city ? std?.city : "--"}
                          </td>
                          <td className="text-nowrap">
                            {std?.country ? std?.country : "--"}
                          </td>
                          <td className="text-nowrap">
                            {std?.homeAddress ? std?.homeAddress : "--"}
                          </td>
                          <td className="text-nowrap">
                            {std?.applicationStatus
                              ? std?.applicationStatus
                              : "--"}
                          </td>
                          <td className="text-nowrap">
                            {std?.submittedDate
                              ? DateTimeFormatter(std?.submittedDate)
                              : "--"}
                          </td>
                          <td className="text-nowrap">
                            {std?.programDuration ? std?.programDuration : "--"}
                          </td>
                          {/* <td className="d-flex">
                              <MdModeEdit
                                style={{ cursor: "pointer" }}
                                className="me-2 text-primary"
                                onClick={() => handleUpdate(staff)}
                                size={18}
                              />
                              <MdDelete
                                style={{ cursor: "pointer" }}
                                className="text-danger"
                                onClick={() => {}}
                                size={18}
                              />
                            </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </div>
            </CardBody>
            <CardFooter>
              <div className="d-flex justify-content-center justify-content-md-end justify-content-lg-end align-items-center flex-wrap">
                <div style={{ marginLeft: "4px" }}>
                  <PaginationComponent
                    totalPages={totalPages}
                    currentPage={currentPage}
                    paginate={paginate}
                  />
                </div>
              </div>
            </CardFooter>
          </Card>
        </Col>
      </Row>
    </div>
  )
}
